<template>
    <div id="manageฉate">
        <div class="row mb-3">
            <div class="col">
                ประเภทค่าใช้จ่าย
                <input type="text" class="form-control" v-model="cate_exp_name" placeholder="ประเภทค่าใช้จ่ายใหม่...">
            </div>
            <div class="col-3 pt-4">
                <button class="btn btn-success btn-block" @click="newCate">เพิ่ม</button>
            </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
                <tr class="text-center">
                  <th scope="col">#</th>
                  <th scope="col">รายการ</th>
                  <th scope="col">ลบ/แก้ไข</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(s, i) in cate_exp_list" :key="'s' + i">
                  <th scope="row">{{ i + 1 }}</th>
                  <td>
                    <input type="text" :class="{ 'hidden-border': edit_status == 0, 'form-control': edit_status == 1 } "
                     v-model="s.cate_exp_name" :readonly="edit_status == 0">
                  </td>
                  <td class="text-center">
                    <button class="btn btn-danger btn-sm"
                      v-if="edit_status == 0"
                     @click="remove(s.cate_exp_id)">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                    <button class="btn btn-warning btn-sm"
                      v-if="edit_status == 0"
                     @click="edit()">
                      <i class="fas fa-pen-square"></i>
                    </button>
                    <button class="btn btn-success btn-sm"
                      v-if="edit_status == 1"
                     @click="update(s.cate_exp_id, s.cate_exp_name)">
                      <i class="fas fa-save"></i>
                    </button>
                    <button class="btn btn-danger btn-sm"
                      v-if="edit_status == 1"
                     @click="edit_status = 0">
                      <i class="fas fa-times"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="cate_exp_list.length < 1">
                  <th scope="row" colspan="3" class="text-center">ไม่มีข้อมูล</th>
                </tr>
            </tbody>
          </table>
        </div>
    </div>
</template>

<style>
  .hidden-border {
    border: 0px!important;
    background: #fff!important;
  }
</style>

<script>
import api from '../services/service_expend'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  data () {
    return {
      cate_exp_list: [],
      cate_exp_name: '',
      edit_status: 0,
      header: {
        headers: {
          'Access-Token': this.$store.state.token
        }
      }
    }
  },
  methods: {
    getCate () {
      this.$store.state.isLoading = true
      var body = {
        search: '',
        active_page: 1,
        per_page: 10000000000000
      }
      api.getCate(
        body,
        this.header,
        result => {
          if (result.response === true) {
            this.cate_exp_list = result.data
            this.edit_status = 0
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    newCate () {
      if (this.sub_cate !== '') {
        const obj = {
          cate_exp_name: this.cate_exp_name
        }

        api.addCateExpen(
          obj,
          this.header,
          result => {
            if (result.response === true) {
              this.alert_msg('success', 'เพิ่มประเภทค่าใข้จ่าย', result.data)
              this.getCate()
              this.cate_exp_name = ''
            } else {
              Swal.fire('ดึงข้อมูลค่าใช้จ่าย', result.message, 'warning')
            }
            this.$store.state.isLoading = false
          },
          error => {
            alert(JSON.stringify(error))
            this.$store.state.isLoading = false
          }
        )
      }
    },
    remove (id) {
      api.delCateExpen(
        id,
        this.header,
        result => {
          if (result.response === true) {
            this.alert_msg('success', 'ลบประเภทค่าใข้จ่าย', result.data)
            this.getCate()
            this.cate_exp_name = ''
          } else {
            Swal.fire('ดึงข้อมูลค่าใช้จ่าย', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    edit () {
      this.edit_status = 1
    },
    update (id, text) {
      const obj = {
        cate_exp_id: parseInt(id),
        cate_exp_name: text
      }
      api.updateCateExpen(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.edit_status = 0
            this.alert_msg('success', 'แก้ไขประเภทค่าใข้จ่าย', result.data)
            this.getCate()
          } else {
            Swal.fire('ดึงข้อมูลค่าใช้จ่าย', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.getCate()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cate_view.vue